import styled from 'styled-components';
import Carousel from '@mlb/react-patterns/v4/components/Carousel/carousel';
import { StyledButton } from '@mlb/react-patterns/v4/components/Button/button.style';
import { DynamicFieldViewWrapper, DynamicFieldViewCanvas, DFVVideo } from '../DynamicFieldView/DynamicFieldView.style';
import { liveViewsTypes } from '../themes/liveViewsTypes';
import { ErrorWrapper } from '../ErrorFallback/ErrorFallback.style';
import GDBREAKPOINTS from '../themes/breakpoints';

const { SINGLE, SINGLEWIDE } = liveViewsTypes;

export const DFVWrapper = styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid var(--gameday-divider-color);
    ${ErrorWrapper} {
        width: 100%;
    }
    ${DynamicFieldViewWrapper} {
        border-bottom: none;
        ${({ $viewType }) => {
            if ($viewType === SINGLE || $viewType === SINGLEWIDE) {
                return `
                            padding: 26px;
                        `;
            }
        }}
        ${DynamicFieldViewCanvas},
        ${DFVVideo} {
            position: relative;
            top: 4%;
        }
    }
`;

export const LiveDFVWrapper = styled.div`
    overflow: hidden;
    vertical-align: top;
    visibility: visible;
    position: relative;
`;

export const CarouselOverride = styled(Carousel)`
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    aspect-ratio: 20 / 17;
    @media (min-width: ${GDBREAKPOINTS.SM_MIN}) {
        aspect-ratio: 25 / 16;
    }
    .react-multi-carousel-dot-list {
        top: 18px;
        bottom: unset;
        width: fit-content;
        border-radius: 8px;
        background: var(--gameday-dfvbuttons-bg-color);
        padding: 4px;
        margin: 0 auto;

        ${StyledButton} {
            color: var(--gameday-primary-font-color);
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 12px;
            padding: 8px;
            border-radius: 7px;
            height: 28px;
            &.active {
                background-color: var(--gameday-dfvbuttons-active-color) !important;
                font-weight: 700;
                color: var(--gameday-dfvbuttons-active-text-color) !important;
            }
        }
    }
`;
